import { LanguageProvider } from 'contexts/LanguageContext';
import AppWeb from 'AppWeb';
import ThemeCustomization from 'themes';

const AppLang = () => {
    return (<ThemeCustomization>
        <LanguageProvider>
            <AppWeb />
        </LanguageProvider>
    </ThemeCustomization>
    );
};

export default AppLang;
